import { getContext, setContext } from "svelte";
import { backgroundSourceStore, candidateStore } from "../../stores";

class ShareResumeContext {
  #candidate = $state({});

  #experience = $state([]);
  #education = $state([]);

  #loading = $state(true);

  get loading() {
    return this.#loading;
  }

  hideName = $state(false);
  hideContactInfo = $state(true);

  expiry = $state(null);

  get name() {
    return this.hideName
      ? this.#candidate.name
          .split(/\s+/)
          .map((x) => x[0])
          .join("")
      : this.#candidate.name;
  }

  get resume() {
    return {
      name: this.name,
      linkedinUrl: this.hideName ? null : this.#candidate.linkedinUrl,
      role: this.#candidate.role,
      emails: this.hideContactInfo ? [] : this.#candidate.emails,
      phones: this.hideContactInfo ? [] : this.#candidate.phones,
      education: this.#education,
      experience: this.#experience,
    };
  }

  buildPayload() {
    return {
      kind: "resume",
      name: `${this.name} - Resume`,
      expiry: this.expiry,
      candidateId: this.#candidate.candidateId,
      resume: this.resume,
    };
  }

  constructor() {
    candidateStore.subscribe((value) => {
      this.#candidate = value;
    });
    backgroundSourceStore.subscribe((value) => {
      this.#experience = value.experience;
      this.#education = value.education;
    });

    backgroundSourceStore.meta.subscribe((meta) => {
      this.#loading = meta.fetching;
    });

    this.expiry = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
  }
}

const SHARE_RESUME_CONTEXT = Symbol("share-resume-context");

export const createShareResumeContext = () => {
  const shareResumeContext = new ShareResumeContext();
  setContext(SHARE_RESUME_CONTEXT, shareResumeContext);
  return shareResumeContext;
};

export const getShareResumeContext = () => getContext(SHARE_RESUME_CONTEXT);
